import { Link, useLocation } from 'react-router-dom'
import './index.scss'

const NAV = [
  { label: 'Work', to: '/work', accent: '#5b9dff' },
  { label: 'Lab', to: '/lab', accent: '#d96aa0' },
  { label: 'Photos', to: '/photos' },
  { label: 'About', to: '/about' },
]

const Header = () => {
  const { pathname } = useLocation()
  const isHome = pathname === '/' || pathname === '/new'

  return (
    <header className={`sh-root${isHome ? ' sh-root--home' : ''}`}>
      <nav className='sh-nav'>
        <Link to='/' className='sh-pill sh-pill--logo'>AB</Link>
        {NAV.map(({ label, to, accent }) => {
          const active = pathname === to || (to === '/blog' && pathname.startsWith('/post/'))
          return (
            <Link
              key={to}
              to={to}
              className={`sh-pill${active ? ' sh-pill--active' : ''}`}
              style={active && accent ? { borderColor: accent } : undefined}
            >
              {label}
            </Link>
          )
        })}
      </nav>
      <Link
        to='/contact'
        className={`sh-pill${pathname === '/contact' ? ' sh-pill--active' : ''}`}
      >
        Contact
      </Link>
    </header>
  )
}

export default Header
